<template>
  <div class="m-fb-center-center m-p-12 m-bg-FFFFFF">
    <m-button @click="handlerOpenFlyout">修改已选时间</m-button>
  </div>
</template>
<script>
import { getSearchObj } from '@/utils/comUtils'
import { opproveUrl } from 'CONFIG'

export default {
  name: 'PageVenueBotton',
  components: {},
  computed: {},
  data() {
    let { spaceResourceId, reserveCacheId } = getSearchObj()
    return {
      reserveCacheId, //缓存预约单id
      spaceResourceId //资源id
    }
  },

  methods: {
    isMobile() {
      let userAgentInfo = navigator.userAgent
      let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
      let getArr = Agents.filter(i => userAgentInfo.includes(i))
      return getArr.length ? true : false
    },
    handlerOpenFlyout() {
      let _url_base = this.isMobile() ? `${opproveUrl}/hom/uni-mobile` : `${opproveUrl}/hom/uni`
      window.InfoPlusSDK.iframe.openFlyout({
        src: `${_url_base}?spaceResourceId=${this.spaceResourceId}&reserveCacheId=${this.reserveCacheId}#/weekview`,
        width: 1000,
        height: 500,
        title: '时间选择',
        position: 'center',
        onClose: data => {
          let _hash = `/button?`
          for (let key in data) {
            if (data.hasOwnProperty.call(data, key)) {
              _hash += `${key}=${data[key]}&`
               window.InfoPlusSDK.iframe.setPropertyValue(key, data[key])
            }
          }
          window.location.hash = _hash
        }
      })
    }
  }
}
</script>
<style></style>
